module.exports = __webpack_public_path__ + "static/media/user-check.6ba69c8b.svg";